module.exports = __webpack_public_path__ + "img/vk.1dff1623.svg";